import React from "react";

export default function Footer({ className = "" }) {
  return (
    <footer
      data-testid="app-footer"
      className={`w-full py-4 text-center text-xs text-slate-400 select-none ${className}`}
    >
      SiMadin © 2026 <span className="mx-1.5 text-slate-300">|</span> Dikembangkan oleh Sunan Giri Media
    </footer>
  );
}
